module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "px-1",
    class: [_vm.color, 'lighten-4'],
    style: (_vm.dayEventStyle(_vm.event, _vm.events)),
    attrs: {
      "flat": "",
      "small": ""
    }
  }, [_c('small', [_c('strong', [_vm._v(_vm._s(_vm.event.title || _vm.event.full_name))]), _c('br'), _vm._v("\n      " + _vm._s(_vm.event.start) + " - " + _vm._s(_vm.event.end) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6efa79a5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/IntervalSlot.vue
// module id = 1667
// module chunks = 3